import { render, staticRenderFns } from "./import-matrix-tags.vue?vue&type=template&id=0d2457d4&scoped=true&"
import script from "./import-matrix-tags.vue?vue&type=script&lang=ts&"
export * from "./import-matrix-tags.vue?vue&type=script&lang=ts&"
import style0 from "./import-matrix-tags.vue?vue&type=style&index=0&id=0d2457d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2457d4",
  null
  
)

export default component.exports